window.app = angular.module('app', ['ngResource']);

window.app.config(['$httpProvider', '$compileProvider', function($httpProvider, $compileProvider) {
	// Set authenticity_token
	if ($('meta[name=csrf-token]').attr('content')) {
		$httpProvider.defaults.headers.common['X-CSRF-Token'] = $('meta[name=csrf-token]').attr('content');
	}

	// Disable Angular debug information on DOM elements
	// See https://docs.angularjs.org/guide/production
	if (window.cfg.env === 'production') {
		return $compileProvider.debugInfoEnabled(false);
	}
}
]);
